{
  "dss": {
    "footer": {
      "legalEntity": "STIHL Limited"
    }
  }
}
